<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Control, FormControl, setupControl } from "./controls";
  import { Validator } from "./validators";
  import type { ControlValidator } from "./validators";

  const dispatch = createEventDispatcher();

  // either set name and validators
  export let name: string = null;
  export let required: boolean = false;
  export let validators: ControlValidator[] = [];
  export let value: { [key: string]: any } = undefined;
  // ... or bind a control
  export let control: FormControl = null;
  export let standalone: boolean = false;

  const changes = setupControl(FormControl, {
    name,
    validators: [...validators, ...(required ? [Validator.required] : [])],
    value,
    control,
    standalone,
    submitEvent: (ctrl) => {
      dispatch("submit", ctrl);
    },
    register: true,
  });
  $: ctrl = $changes;

  let oldValue = value;
  $: if (value !== oldValue) {
    oldValue = value;
    ctrl.value = value;
  }
</script>

<slot control={ctrl} errors={ctrl.errors} />
